import clsx from "clsx";
import { Categories, Category } from "services-hooks/types";
import styles from "./region-countries.module.scss";
import { useRef } from "react";
import { useGetPillowCategoryPath } from "services-hooks/hooks";
import Image from "next/image";
import MemoLogo from "../icons/Logo";
import Link from "next/link";
import { SwaggerResponse } from "services-hooks/config";

export interface RegionCountriesProps {
  regionPermalink: string;
  label?: string;
  countries: Category[];
  showDetailsOnClick?: boolean;
  wrapped?: boolean;
  rows?: number;
  className?: string;
  showNames?: boolean;
}

export const RegionCountries: React.FC<RegionCountriesProps> = ({
  regionPermalink,
  countries,
  label,
  className,
}) => {
  const radioListRef = useRef<HTMLDivElement>(null);
  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={styles.header}>{<h2>{label}</h2>}</div>
      <div className={styles.radio_list} ref={radioListRef}>
        {countries.map((country, index) => {
          const countryPermalinkSplit = country.permalink?.split("/");
          const countryCode =
            countryPermalinkSplit && countryPermalinkSplit.length > 0
              ? countryPermalinkSplit[countryPermalinkSplit.length - 1]
              : null;
          return (
            countryCode && (
              <Link
                href={`/navigation-map/${countryCode}`}
                key={`radio-station-${index}`}
                passHref
              >
                <a
                  className={clsx(
                    styles.radio_station,
                    styles.show_station_names
                  )}
                >
                  {country?.logo || country?.logo ? (
                    <Image
                      className={styles.cover}
                      src={country?.logo || country?.logo || ""}
                      width={100}
                      height={100}
                      layout="fixed"
                      objectFit="cover"
                      alt=""
                      unoptimized
                    />
                  ) : (
                    <div className={clsx(styles.cover, styles.no_image)}>
                      <MemoLogo />
                    </div>
                  )}
                  <div className={styles.station_title}>{country.name}</div>
                </a>
              </Link>
            )
          );
        })}
      </div>
    </div>
  );
};
